import { InvoiceStatus } from '@/enums/invoiceStatus.enum';
import { PackStatus } from '@/enums/packStatus.enum';
import { PaymentState } from '@/enums/paymentState';
import { Action } from '@/interfaces/action';

export const APP_AMOUNT_LOCALE = 'fr-FR';
export const AUTOSAVE = 'Autozapis';
export const TOKEN_HEADER = 'Token';

export const ADD_COLOR = '#53B955';

export const ASSESSMENT_COLOR = '#000000';

export const ATTACHMENT_COLOR = '#000000';

export const BUTTONS_COLOR = '#000000';

export const SET_STATUS_COLOR = (object: any) => object.status && object.status.color;

export const DELETE_COLOR = '#ee0000';

export const EDIT_COLOR = '#000000';

export const GO_TO_MESSAGE_ENTITY_COLOR = '#1b69b6';

export const DOWNLOAD_MEDIA_COLOR = '#000000';

export const OPTIONS_COLOR = '#4C6EF5';

export const ROLES_COLOR = '#4e4e4e';

export const VIEW_COLOR = '#0F00FF';

export const RECEIVE_COLOR = '#53B955';

export const EDIT_ACTION: Action = {
  class: 'btn-edit',
  color: EDIT_COLOR,
  event: 'edit',
  icon: 'fal fa-fw fa-pencil',
  module: 'edit',
  permissionTypes: ['UPDATE'],
  tooltipText: 'Edytuj'
};

export const EDIT_PAYMENT_DATA_ACTION: Action = {
  class: 'btn-edit',
  color: EDIT_COLOR,
  event: 'edit',
  icon: 'fal fa-fw fa-pencil',
  permissions: [],
  tooltipText: 'Edytuj dane do wypłaty'
};

export const RESTORE_PAYMENT_DATA_ACTION: Action = {
  class: 'btn-cancel',
  color: DELETE_COLOR,
  event: 'restore',
  icon: 'fal fa-fw fa-ban',
  permissions: [],
  tooltipText: 'Przywróć oryginalne dane'
};

export const DELETE_ACTION: Action = {
  class: 'btn-delete',
  color: DELETE_COLOR,
  event: 'delete',
  icon: 'fal fa-fw fa-trash',
  permissionTypes: ['DELETE'],
  tooltipText: 'Usuń'
};

export const ADD_ACTION: Action = {
  class: 'btn-add',
  color: ADD_COLOR,
  event: 'add',
  icon: 'fal fa-fw fa-plus',
  permissionTypes: ['ADD'],
  tooltipText: 'Dodaj'
};

export const ROLES_ACTION: Action = {
  class: 'btn-roles',
  color: ROLES_COLOR,
  event: 'roles',
  icon: 'fal fa-sitemap',
  permissionTypes: ['ROLE_MANAGE'],
  tooltipText: 'Role'
};

export const VIEW_ACTION: Action = {
  class: 'btn-view',
  color: VIEW_COLOR,
  event: 'view',
  icon: 'fal fa-fw fa-address-card',
  permissionTypes: ['GET'],
  tooltipText: 'Szczegóły'
};

export const VIEW_DOCUMENT_ACTION: Action = {
  class: 'btn-view',
  color: VIEW_COLOR,
  event: 'viewDocument',
  icon: 'fal fa-fw fa-file',
  permissions: [],
  tooltipText: 'Szczegóły wniosku'
};

export const UP_ACTION: Action = {
  color: ROLES_COLOR,
  event: 'up',
  icon: 'fal fa-arrow-alt-up ',
  permissionTypes: ['UPDATE'],
  tooltipText: 'Kolejność w górę'
};

export const DOWN_ACTION: Action = {
  color: ROLES_COLOR,
  event: 'down',
  icon: 'fal fa-arrow-alt-down',
  permissionTypes: ['UPDATE'],
  tooltipText: 'Kolejność w dół'
};

export const ASSESSMENT_ACTION: Action = {
  color: ASSESSMENT_COLOR,
  event: 'assessment',
  icon: 'fal fa-clipboard',
  module: 'assessment',
  permissions: ['ASSESSMENT.ADD'],
  tooltipText: 'Ocena'
};

export const ASSESSMENT_SUMMARY_ACTION: Action = {
  color: ASSESSMENT_COLOR,
  event: 'assessmentSummary',
  icon: 'fal fa-clipboard-check',
  module: 'assessment',
  permissions: ['ASSESSMENT.ADD'],
  tooltipText: 'Wyniki oceny'
};

export const SET_STATUS_ACTION: Action = {
  color: SET_STATUS_COLOR,
  event: 'setStatus',
  forceNoEntity: true,
  icon: 'fas fa-circle',
  permissionTypes: ['SET_STATUS'],
  tooltipText: 'Zmień status'
};

export const CRITERION_ACTION: Action = {
  color: SET_STATUS_COLOR,
  event: 'editCriterion',
  icon: 'fas fa-adjust',
  permissionTypes: ['UPDATE'],
  tooltipText: 'Kryteria'
};

export const OPTION_ACTION: Action = {
  color: OPTIONS_COLOR,
  event: 'editOptions',
  icon: 'fas fa-sliders-h',
  permissionTypes: ['UPDATE'],
  tooltipText: 'Opcje'
};

export const BUTTONS_ACTION: Action = {
  color: BUTTONS_COLOR,
  event: 'buttons',
  icon: 'fas fa-bars',
  permissions: ['BUTTON.LIST'],
  tooltipText: 'Przyciski'
};

export const ATTACHMENT_ACTION: Action = {
  color: ATTACHMENT_COLOR,
  event: 'attachments',
  icon: 'fal fa-paperclip',
  permissions: ['ATTACHMENT.LIST'],
  tooltipText: 'Załączniki'
};

export const DOWNLOAD_MEDIA_ACTION: Action = {
  color: DOWNLOAD_MEDIA_COLOR,
  event: 'download',
  icon: 'fal fa-cloud-download',
  permissions: ['MEDIA.GET'],
  tooltipText: 'Pobierz załącznik'
};

export const GO_TO_MESSAGE_ENTITY_ACTION: Action = {
  color: GO_TO_MESSAGE_ENTITY_COLOR,
  event: 'goToEntity',
  icon: ' fal fa-external-link',
  permissionTypes: ['GET']
};

export const RECEIVE_ACTION: Action = {
  check: object => object.status === PackStatus.SENT,
  color: RECEIVE_COLOR,
  event: 'receive',
  icon: 'fas fa-check',
  permissions: ['DOCUMENT_PACK.UPDATE'],
  tooltipText: 'Odbierz'
};

export function GO_TO_MDOK_ACTION(isSecretary: boolean): Action {
  return {
    check: object => (isSecretary ? !!object.systemNumbers?.mdokJoId : !!object.systemNumbers?.mdokId),
    event: 'goToMdok',
    icon: 'fas fa-link',
    permissions: ['DOCUMENT.MDOK'],
    tooltipText: 'Przejdź do MDOK'
  };
}

export const DOWNLOAD_ACTION: Action = {
  event: 'download',
  icon: 'fas fa-download',
  tooltipText: 'Pobierz',
  permissions: []
};

export const CANCEL_ACTION: Action = {
  check: (object: any) =>
    (object.pack.status === PaymentState.NOT_SENT || object.pack.status === PaymentState.UNCONFIRMED) &&
    object.state !== PaymentState.CANCELED &&
    !object.externalId,
  event: 'cancel',
  icon: 'fas fa-ban',
  tooltipText: 'Anuluj w systemie Witkac',
  permissions: ['PAYMENT.DELETE']
};

export const CANCEL_KSAT_ACTION: Action = {
  check: (object: any) =>
    object.pack.status === PaymentState.UNCONFIRMED && object.externalId && object.state !== PaymentState.CANCELED,
  event: 'cancelKsat',
  icon: 'fas fa-file-excel',
  tooltipText: 'Anuluj w KSAT',
  permissions: ['PAYMENT.DELETE']
};

export const REATTACH_ACTION = {
  check: (object: any) => object.state === PaymentState.NOT_ATTACHED,
  event: 'reattach',
  icon: 'fas fa-sync',
  tooltipText: 'Dołącz do paczki w KSAT',
  permissions: ['PAYMENT.UPDATE']
};

export const RESEND_ACTION = {
  check: (object: any) =>
    object.state !== PaymentState.CANCELED &&
    object.pack.status === PaymentState.CONFIRMED &&
    object.pack.externalId &&
    (!object.externalId || object.state === PaymentState.FAILURE),
  event: 'resend',
  icon: 'fas fa-sync',
  tooltipText: 'Prześlij płatność do KSAT',
  permissions: ['PAYMENT.UPDATE']
};

export const EDIT_INVOICE_ACTION = {
  ...EDIT_ACTION,
  check: (object: any) => object.status !== InvoiceStatus.APPROVED
};

export const DELETE_INVOICE_ACTION = {
  ...DELETE_ACTION,
  check: (object: any) => object.status !== InvoiceStatus.APPROVED
};

export const APPROVE_INVOICE_ACTION = {
  color: OPTIONS_COLOR,
  event: 'approve',
  icon: 'fas fa-check',
  permissions: ['INVOICE.VERFIFICATION.APPROVE'],
  tooltipText: 'Zatwierdź',
  check: (object: any) => object.status !== InvoiceStatus.APPROVED
};

export const UNLOCK_INVOICE_ACTION = {
  color: OPTIONS_COLOR,
  event: 'unlock',
  icon: 'fas fa-undo',
  permissions: ['INVOICE.VERFIFICATION.UNLOCK'],
  tooltipText: 'Odblokuj',
  check: (object: any) => object.status === InvoiceStatus.APPROVED
};

export const DEFAULT_TABLE_ACTIONS = [EDIT_ACTION, DELETE_ACTION];

export const MEDIA_URL = process.env.VUE_APP_MEDIA_URL;

export const TILES_URL = process.env.VUE_APP_TILES_URL;

export const DEFAULT_COUNT = 20;

export const UNAUTHORIZED_MESSAGES = [
  "Access denied! You don't have permission for this action!",
  'Access denied! You need to be authorized to perform this action!',
  'Brak uprawnień.'
];

export const YES_OR_NO = [
  { value: true, text: 'TAK' },
  { value: false, text: 'NIE' }
];

export const MONTHS = [
  { value: 0, text: 'Styczeń' },
  { value: 1, text: 'Luty' },
  { value: 2, text: 'Marzec' },
  { value: 3, text: 'Kwiecień' },
  { value: 4, text: 'Maj' },
  { value: 5, text: 'Czerwiec' },
  { value: 6, text: 'Lipiec' },
  { value: 7, text: 'Sierpień' },
  { value: 8, text: 'Wrzesień' },
  { value: 9, text: 'Październik' },
  { value: 10, text: 'Listopad' },
  { value: 11, text: 'Grudzień' }
];

export const DE_MINIMIS_TITLE = [
  { value: true, text: 'IV. Oświadczenie o wysokości otrzymanej pomocy de minimis' },
  { value: false, text: 'IV. Oświadczenie o nieotrzymywaniu pomocy de minimis' }
];

export const YES_NO_NOT = [
  { value: 1, text: 'TAK' },
  { value: 2, text: 'NIE' },
  { value: 3, text: 'NIE DOTYCZY' }
];

export const GENDER = [
  { value: 1, text: 'Pan' },
  { value: 2, text: 'Pani' }
];

export const VALIDATE_DATA_FUNCTIONS = [
  { functionName: 'validateSensitiveData', schemaField: 'sensitiveDataValidation' },
  { functionName: 'validateDuplicatedData', schemaField: 'duplicatedDataValidation' }
];

export const INFORMATION_LINKS = {
  stypendia:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/polityka-prywatnosci/klauzula-informacyjna-stypendium-zasilek/',
  dofinansowanie:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/polityka-prywatnosci/klauzula-informacyjna-pracownik-mlodociany/',
  wyroznienia:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/polityka-prywatnosci/klauzula-informacyjna-stypendia-prezydenta/',
  duplikaty:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/polityka-prywatnosci/klauzula-informacyjna-duplikat-swiadectwa/'
};

// FIXME: Uzupełnić prawidłowymi linkami jak je dostaniemy
export const WCAG_LINKS = {
  stypendia:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/deklaracje-dostepnosci-/deklaracja-dostepnosci-stypendia/',
  dofinansowanie:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/deklaracje-dostepnosci-/deklaracja-dostepnosci-dofinansowanie/',
  wyroznienia:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/deklaracje-dostepnosci-/deklaracja-dostepnosci-wyroznienia/',
  duplikaty:
    'https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/deklaracje-dostepnosci-/deklaracja-dostepnosci-duplikaty/'
};
